/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  private baseUrl = `${environment.endpoint}common/units`;

  constructor(private httpHelperService: HttpHelperService) {}

  async get(data?: { baseId: string } | void): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'POST',
        this.baseUrl,
        data
      );
    } catch (error) {
      throw error;
    }
  }
}
/*
 *   Copyright (c) 2020
 *   All rights reserved.
 *   Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon,
 *  LLC Proprietary.All rights reserved.  2020 WARNING: this file may contain export controlled information.
 */
